// AUTO-GENERATED by bin/extract_legal_docs.py — do not edit by hand.
// Source: privacy_policy.md (canonical markdown)
// Generated text hash (sha256): 5ce83e5d9a05922d22c7128a842fb766c3dfaaffa5bfef2611605dca7e073b5c

const content = `XPERT.COMPANY

operating xpert.company

Privacy Policy

Multi-jurisdiction notice (UAE · India · EU/UK · United States)

Version 1.1 · Effective 8 July 2026 · Issued by the Office of the Chief Legal & Compliance Officer (CLCO)

# 1. Who we are and how to contact us

This Privacy Policy explains how Xpert.Company FZ-LLC, a UAE company registered in Dubai ("Xpert.Company", "we", "us"), the operator of xpert.company and the xpert.company mobile applications (the "Service"), collects and processes personal data. Our Data Protection Contact is Ankit Kumar, reachable at privacy@xpert.company. Our Grievance Officer for India under the DPDPA and the IT Rules 2021 is Ankit Kumar, reachable at grievance.in@xpert.company. We are in the process of appointing local representatives under Article 27 of the EU GDPR and the UK GDPR; until that appointment is complete, individuals in the EU and the UK may contact us directly at privacy@xpert.company, for the attention of Ankit Kumar. Our registered office is Xpert.Company FZ-LLC, Dubai, United Arab Emirates (full free-zone address available on request at privacy@xpert.company).

# 2. Personal data we collect

Depending on your interaction with the Service, we collect the following categories of personal data:

Identity and contact data: name, email, phone number, country, company, profile photo.

Account data: username, hashed password, security log events, language, currency.

Expert-specific data (Experts only): biography, expertise areas, hourly rate, availability, government ID and bank account information for KYC and payouts (processed by Stripe or Razorpay), tax identifiers.

Booking and transaction data: who booked whom, when, for how long, for how much, payment status, refunds.

Communication data: messages between you and Experts on the Service, support tickets, marketing engagement.

Session data: video recordings and AI-generated transcripts and summaries (only where all participants have given express consent through the in-call consent flow).

Device and usage data: IP address, device identifiers, browser type, OS, pages visited, clickstream, time-stamped audit logs.

Cookies and similar technologies: see our Cookie Policy at xpert.company/legal/cookies.

Sensitive and specially-protected data: To onboard Experts and meet anti-money-laundering, tax and payout obligations, we collect government-issued identity documents and financial account details. Under the CCPA/CPRA these are "sensitive personal information"; we use them only for identity verification, fraud and sanctions screening, payouts and legal compliance, and never to infer characteristics about you or for advertising. We do not otherwise seek special-category data (health, race, religion, biometrics, etc.). Please do not include special-category data in messages or sessions unless strictly necessary; this platform is not the right venue for protected-class disclosures.

# 3. Why we process your personal data and our lawful bases

We rely on different lawful bases depending on the purpose:

Purpose

Lawful basis (EU/UK GDPR)

Equivalent (UAE/India/US)

Create and manage your account

Contract necessity (Art. 6(1)(b))

PDPL contract; DPDPA contract; CCPA service-provider relationship

Match Seekers and Experts; complete bookings

Contract necessity

Same

Process payments, refunds, payouts

Contract necessity; legal obligation for tax

Same

Send transactional emails

Contract necessity

Same

Send marketing emails / push

Consent (opt-in)

PDPL consent; DPDPA consent; CCPA opt-out for sale/share

Session recording and AI processing

Consent

PDPL consent; DPDPA consent; CA two-party consent

Fraud prevention, security, audit

Legitimate interests; legal obligation

PDPL legitimate; DPDPA legitimate uses; CCPA security

Sanctions screening

Legal obligation; legitimate interests

Same

Statutory record-keeping (tax, AML)

Legal obligation

Same

Product analytics (PostHog)

Consent (Art. 6(1)(a)) — analytics does not run until you accept analytics cookies

PDPL consent; DPDPA consent; CCPA: treated as opt-outable "sharing" where applicable, honouring GPC

AI-assisted expert vetting and Seeker–Expert matching (semantic search over profiles and briefs)

Legitimate interests (Art. 6(1)(f)) — to operate the marketplace and surface relevant Experts; you may object

PDPL legitimate interest; DPDPA legitimate use; CCPA business purpose

Processing your submitted content (briefs, messages, files, review requests) with third-party AI models to generate matches, embeddings and review outputs

Contract necessity for the requested service; Consent where the content is session recording/transcription

PDPL contract/consent; DPDPA contract/consent; CCPA business purpose (no sale/share)

# 4. How we share personal data

We share personal data only as needed and only with categories of recipients described below. We do not sell your personal data. We may "share" personal data for cross-context behavioural advertising only if you opt in to non-essential cookies, as those terms are defined under the CCPA/CPRA; you can opt out at any time via Cookie Settings or by sending a Global Privacy Control (GPC) signal, which we honour.

Other users: Experts see Seekers' names and booking details; Seekers see Experts' profiles.

Payment processors: Stripe (global) and Razorpay (India).

Communication and infrastructure providers: Daily.co / Pluot Labs (video, recording, transcripts), Fly.io (application hosting), Supabase (database, authentication and file storage), Google (OAuth sign-in, and — only if you connect them — Calendar and Gmail), Resend (transactional email), and Anthropic and OpenAI (AI processing — see Section 4a). A current, complete list of sub-processors is maintained at xpert.company/legal/subprocessors.

Analytics and error-monitoring tooling: PostHog (product analytics, United States region) and Sentry (error and performance monitoring). Analytics loads only after you consent to non-essential cookies; error monitoring runs as an essential service to keep the platform secure and available.

Professional advisers: lawyers, accountants and auditors under confidentiality.

Public authorities: where required by valid legal process; we will resist over-broad requests and notify users to the extent legally permitted.

Corporate transactions: in connection with a merger, acquisition or sale of assets, in which case we will give you notice and choice where required.

A current list of sub-processors and their data locations is at xpert.company/legal/subprocessors and in our Data Processing Addendum.

# 4a. AI processing of your content

To power matching, embeddings, transcription and summaries, we send relevant content you provide — such as booking briefs, messages, uploaded files, review requests, and (with consent) session audio and transcripts — to our AI sub-processors, currently Anthropic (Claude) and OpenAI (embeddings and transcription fallback). These providers act on our documented instructions under zero-retention terms: they do not use your content to train their models, and they delete it after processing. We do not use your content to train our own general-purpose models.

# 5. International transfers

Personal data may be processed in countries other than your country of residence, including the United States, the European Union, India and the United Arab Emirates. Where data is transferred out of the EEA, the UK or the UAE, we rely on the following safeguards:

Standard Contractual Clauses approved by the European Commission, with module-appropriate annexes.

The UK International Data Transfer Agreement or the UK Addendum to the SCCs.

Adequacy decisions where available.

Transfer Impact Assessments documenting risk and mitigations.

For transfers to the United States (including our analytics, error-monitoring, payment and AI providers): we rely on the EU-US and UK Data Privacy Framework where the importer is certified, and otherwise on the Standard Contractual Clauses with a documented Transfer Impact Assessment.

For UAE transfers: we rely on Articles 22–23 of the UAE PDPL (Federal Decree-Law No. 45 of 2021) — transfer to jurisdictions recognised as adequate by the UAE Data Office, or, absent adequacy, appropriate contractual safeguards, your explicit consent, or a contract-necessity exception.

For India: transfer to any country other than those notified as restricted by the Central Government under the DPDPA.

# 6. How long we keep personal data

We follow the published Records Retention Schedule. Headline rules:

Account profile: while your account is open, then deleted or anonymised 90 days after closure — except identity fields embedded in booking, payment and tax records, which we must retain for 7 years for legal compliance.

Booking, payment and tax records: 7 years.

Session recordings and transcripts: 90 days (extendable on user request up to 365 days).

Marketing data: 24 months from last interaction (anonymised thereafter).

Security and audit logs: 12 months (anonymised thereafter).

Analytics and error data: PostHog product-analytics events are retained for 12 months; Sentry error events for 90 days, then deleted.

AI-derived data: embeddings and vectors generated from your content to power matching are deleted or de-linked when the underlying content is deleted or your account closes.

# 7. Your rights

Subject to the law of your jurisdiction, you have the following rights. Submit any request via xpert.company/legal/privacy-request, by email to privacy@xpert.company, or by post to our registered address.

Right to access — receive a copy of your personal data and information about how we process it.

Right to rectification — correct inaccurate data.

Right to erasure ("right to be forgotten") — subject to exceptions for legal-obligation retention.

Right to restriction of processing.

Right to object — including to marketing and to processing based on legitimate interests.

Right to data portability — receive your data in a machine-readable format.

Right to withdraw consent — at any time, without affecting prior processing.

CCPA/CPRA rights — to know, to delete, to correct, to limit use of sensitive personal information, to opt out of sale or sharing, and to non-discrimination.

DPDPA rights — to access, correction, erasure, grievance redressal and nomination.

UAE PDPL rights — to information, access, correction, erasure, restriction, transfer, objection to automated decisions, withdraw consent.

We will respond within the statutory timeframe (GDPR 30 days, extendable; CCPA 45 days, extendable; DPDPA without undue delay; UAE PDPL 30 days, extendable). You have the right to lodge a complaint with your local supervisory authority: ICO (UK), CNIL or other lead DPA (EU), UAE Data Office, India Data Protection Board, California Privacy Protection Agency.

# 8. Security

We implement technical and organisational measures appropriate to the risk, including encryption in transit (TLS 1.2+), encryption at rest (AES-256), field-level encryption for sensitive identifiers, access controls, audit logging, account lockout, rate limiting, dependency scanning, and a documented incident response process. No system is perfectly secure; if a breach occurs, we will notify regulators within statutory timeframes and you where required.

# 9. Children

The Service is intended only for users aged 18 and over. We do not permit or knowingly collect personal data from anyone under 18. If you believe someone under 18 has provided us with personal data, contact privacy@xpert.company and we will delete it.

# 10. Automated decision-making

We use AI systems to help operate the marketplace — including semantic matching of Seekers to Experts, ranking and surfacing profiles, assisting with Expert vetting, and generating session transcripts and summaries. These systems influence what you see but do not, by themselves, make decisions producing legal or similarly significant effects about you. Consequential decisions — account termination, payout suspension, sanctions determinations, and rejection of an Expert application — always involve meaningful human review before they take effect. You can ask us for information about the logic involved, express your point of view, and contest an outcome by contacting privacy@xpert.company. Under the UAE PDPL and GDPR you may object to decisions based solely on automated processing.

# 11. State-specific rights (United States)

California residents: see the "Notice at Collection" and the Limit Use of Sensitive Personal Information link in the footer. We do not sell personal data, but "sharing" for cross-context behavioural advertising may occur if you opt in to non-essential cookies; opt out via the Cookie Settings link or by sending a GPC signal. We have not knowingly sold or shared the personal data of consumers under 16.

Residents of Virginia, Colorado, Connecticut, Utah, Texas, Oregon, Montana and other states with comprehensive privacy laws have rights similar to those of California residents.

# 12. Changes to this Policy

We may amend this Policy. For material changes we will notify you in-product or by email at least 30 days before they take effect, except where a shorter period is required by law.

# 13. Effective date

This Policy is effective on 8 July 2026. Version 1.1. It supersedes Version 1.0 (effective 1 June 2026).
`;

export default content;
